import type { CSSProperties, ReactNode } from "react";

/**
 * Cartão / painel (Design.md §9). Fundo `--panel`, raio 9–12px (§3.4), sombra
 * `--shadow`. Título opcional (14–15px/700) com slot de ações à direita.
 */
export interface CardProps {
  children: ReactNode;
  title?: ReactNode;
  actions?: ReactNode;
  padding?: number | string;
  style?: CSSProperties;
}

export function Card({
  children,
  title,
  actions,
  padding = "1rem 1.1rem",
  style
}: CardProps): ReactNode {
  const merged: CSSProperties = {
    background: "var(--panel)",
    border: "1px solid var(--border-soft)",
    borderRadius: 11,
    boxShadow: "var(--shadow)",
    padding,
    ...(style ?? {})
  };

  const hasHeader = title !== undefined || actions !== undefined;

  return (
    <section style={merged}>
      {hasHeader ? (
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "0.75rem",
            marginBottom: "0.85rem"
          }}
        >
          <div style={{ fontSize: 14.5, fontWeight: 700 }}>{title}</div>
          {actions !== undefined ? <div>{actions}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}
